import { messages } from 'i18n';

export class ForbiddenError extends Error {
  constructor() {
    super(messages.general.operationForbidden);
  }
}
